<p-button
  [severity]="buttonStyle().severity"
  [variant]="buttonStyle().variant"
  [fluid]="true"
  (onClick)="toggleAccordion()"
  [styleClass]="classOverrides()"
>
  <!-- sequence -->
  @if (showSequence()) {
    <h3 class="select-none text-xl">{{ sequence() }}.</h3>
  }

  <h3
    class="flex cursor-pointer select-none items-center gap-2"
    [class]="textClasses()"
  >
    @if (addShowLabel()) {
      <span>
        @if (!localIsVisible()) {
          Show
        }
        @if (localIsVisible()) {
          Hide
        }
      </span>
    }
    <span>{{ label() }}</span>
    @if (labelHighlightIconPath()) {
      <svg-icon
        class="content-center"
        [class]="'text-' + labelHighlightIconColor() + '-600'"
        [src]="labelHighlightIconPath()"
      />
    }
  </h3>

  <div class="ml-auto grid auto-cols-max grid-flow-col gap-x-2.5">
    @if (showRightLabel()) {
      <span class="content-center" [class]="textClasses()">{{
        rightLabel()
      }}</span>
    }
    @if (!localIsVisible()) {
      <svg-icon
        class="content-center"
        src="/assets/icons/general/chevron-right.svg"
      />
    }
    @if (localIsVisible()) {
      <svg-icon
        class="content-center"
        src="/assets/icons/general/chevron-down.svg"
      />
    }
  </div>
</p-button>
